import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-15328203")

_pushScopeId("data-v-15328203")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "カルテ追加", -1)
const _hoisted_2 = { class: "date-information-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "information-title" }, "カルテ日付：", -1)
const _hoisted_4 = { class: "date-information-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "information-title" }, "診察時刻有無：", -1)
const _hoisted_6 = {
  key: 0,
  class: "date-information-row"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "information-title" }, "開始時刻：", -1)
const _hoisted_8 = {
  key: 1,
  class: "date-information-row"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "information-title" }, "終了時刻：", -1)
const _hoisted_10 = { class: "date-information-row" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "information-title" }, "テンプレート：", -1)
const _hoisted_12 = { class: "button-frame" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("カルテ作成 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("閉じる ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_button_middle = _resolveComponent("icon-button-middle")
  const _component_toggle_radio_switch = _resolveComponent("toggle-radio-switch")
  const _component_time_edit_box = _resolveComponent("time-edit-box")
  const _component_list_box = _resolveComponent("list-box")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_small_calendar = _resolveComponent("small-calendar")
  const _component_floating = _resolveComponent("floating")
  const _component_white_backdrop = _resolveComponent("white-backdrop")

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    _createVNode(_component_white_backdrop, { show: _ctx.show }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", {
          class: ["frame", _ctx.$mq]
        }, [
          _hoisted_1,
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode("div", null, _toDisplayString(_ctx.editDateString), 1),
            _createVNode(_component_icon_button_middle, {
              class: "calendar-button",
              icon: "calendar",
              state: "normal",
              onClick: _ctx.onCalendar
            }, null, 8, ["onClick"])
          ]),
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_toggle_radio_switch, {
              "group-id": "karte-template-modal-enable-time",
              modelValue: _ctx.enableTime,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.enableTime = $event))
            }, null, 8, ["modelValue"])
          ]),
          (_ctx.enableTime)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_time_edit_box, {
                  class: "time-control",
                  placeholder: "開始時刻",
                  modelValue: _ctx.editStartTime,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editStartTime = $event)),
                  interval: _ctx.appointmentTimeUnit
                }, null, 8, ["modelValue", "interval"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.enableTime)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_time_edit_box, {
                  class: "time-control",
                  placeholder: "終了時刻",
                  modelValue: _ctx.editEndTime,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editEndTime = $event)),
                  interval: _ctx.appointmentTimeUnit
                }, null, 8, ["modelValue", "interval"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_list_box, {
              class: "template-list",
              title: "カルテテンプレート",
              items: _ctx.karteTemplateListItems,
              modelValue: _ctx.selectedTemplateId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedTemplateId = $event)),
              size: Math.min(6, _ctx.karteTemplateListItems.length)
            }, null, 8, ["items", "modelValue", "size"])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_normal_button, {
              ref: "yes",
              type: "button",
              class: "button",
              state: "confirm",
              disabled: _ctx.errorEditStartTime !== undefined || _ctx.errorEditEndTime !== undefined,
              onClick: _ctx.onYes
            }, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_normal_button, {
              type: "button",
              class: "button",
              state: "confirm",
              onClick: _ctx.dismiss
            }, {
              default: _withId(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_floating, { ref: "floatingRef" }, {
            default: _withId(() => [
              _createVNode(_component_small_calendar, {
                ref: "calendarRef",
                onSelect: _ctx.onSelectDate
              }, null, 8, ["onSelect"])
            ]),
            _: 1
          }, 512)
        ], 2), [
          [_vShow, _ctx.show]
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
})